import { VerificationTypeId } from '@gig/magic-sdk/dist/adapter/signup/registrationTypes';

var VerificationTypes = {
    EMAIL: VerificationTypeId.EMAIL,
    SMS: VerificationTypeId.SMS,
    SMS_AND_EMAIL: VerificationTypeId.SMS_AND_EMAIL,
    MANUAL: VerificationTypeId.MANUAL,
};
/**
 * Gets the verification method associated with the sign up country.
 * @param country The current registration selected country
 * @param preferred The preferred methods of verification if available
 */
function getVerificationMethod(country, preferred) {
    var countryMethods = (preferred[country] || preferred.DEFAULT || []).map(function (name) { return VerificationTypes[name]; });
    return countryMethods.length ? countryMethods[0] : VerificationTypeId.SMS;
}

export { VerificationTypes, getVerificationMethod };
